
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Calendar } from 'lucide-react';

interface CallToActionProps {
  locationName: string;
  address: string;
  phone: string;
  email: string;
}

const CallToAction: React.FC<CallToActionProps> = ({
  locationName,
  address,
  phone,
  email
}) => {
  const assessmentIncludes = [
    "Comprehensive roof inspection",
    "Drone documentation with 4K imagery",
    "Moisture analysis and detection",
    "Energy efficiency review",
    "Investment planning with financing options",
    "Insurance consultation and coverage optimization"
  ];

  const serviceHours = [
    { day: "Monday-Friday:", hours: "7:00 AM - 6:00 PM" },
    { day: "Saturday:", hours: "8:00 AM - 4:00 PM" },
    { day: "Sunday:", hours: "Emergency services only" },
    { day: "24/7 Emergency Line:", hours: "Always available" }
  ];

  return (
    <section className="text-center bg-brand-carolina-blue text-white p-8 rounded-lg">
      <h2 className="text-3xl font-bold mb-4 flex items-center justify-center">
        <Calendar className="h-8 w-8 mr-3" />
        Get Your Free {locationName} Roofing Assessment
      </h2>
      
      <div className="grid md:grid-cols-3 gap-6 mb-8 text-left">
        <div className="text-center">
          <MapPin className="h-8 w-8 mx-auto mb-2" />
          <h3 className="font-bold mb-1">Visit Us:</h3>
          <p>{address}</p>
        </div>
        <div className="text-center">
          <Phone className="h-8 w-8 mx-auto mb-2" />
          <h3 className="font-bold mb-1">Call/Text:</h3>
          <p>{phone}</p>
        </div>
        <div className="text-center">
          <Mail className="h-8 w-8 mx-auto mb-2" />
          <h3 className="font-bold mb-1">Email:</h3>
          <p>{email}</p>
        </div>
      </div>

      <div className="mb-6">
        <h3 className="text-xl font-bold mb-4">What's Included in Your Free Assessment:</h3>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 text-left">
          {assessmentIncludes.map((item, index) => (
            <p key={index}>• {item}</p>
          ))}
        </div>
      </div>

      <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
        <Link to="/contact">
          <Button size="lg" className="bg-brand-safety-orange text-white hover:bg-brand-safety-orange/90">
            Get Your Free Assessment
          </Button>
        </Link>
        <Button size="lg" variant="outline" className="bg-white text-brand-carolina-blue border-white hover:bg-gray-100 hover:text-brand-carolina-blue">
          <Phone className="h-5 w-5 mr-2" />
          Call {phone}
        </Button>
      </div>

      <div className="mt-6 text-sm">
        <h4 className="font-bold mb-2">Service Hours:</h4>
        <div className="grid md:grid-cols-2 gap-2">
          {serviceHours.map((schedule, index) => (
            <p key={index}>{schedule.day} {schedule.hours}</p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
